module.exports = __webpack_public_path__ + "static/img/3-8.db5dd4b5.png";